import { render, staticRenderFns } from "./BlankContent.vue?vue&type=template&id=e3fc2044&scoped=true&"
import script from "./BlankContent.vue?vue&type=script&lang=ts&"
export * from "./BlankContent.vue?vue&type=script&lang=ts&"
import style0 from "./BlankContent.vue?vue&type=style&index=0&id=e3fc2044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc2044",
  null
  
)

export default component.exports